import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const YonghuShangchuan = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb43b__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb43b__a)">
            <path
              fillRule="evenodd"
              d="M35.585 28.587v-.001c.36-.36.857-.583 1.406-.586h.019a1.994 1.994 0 0 1 1.404.586l4 4a2 2 0 1 1-2.828 2.828L39 34.828V40a2 2 0 1 1-4 0v-5.172l-.586.586a2 2 0 1 1-2.828-2.828l3.999-4ZM6 44h21a2 2 0 1 0 0-4H8.001q.01-3.174.101-4.291.132-1.608.552-2.433.885-1.737 2.622-2.622.825-.42 2.432-.552Q14.961 30 18.8 30H27a2 2 0 1 0 0-4h-8.2q-4.002 0-5.417.116-2.395.195-3.923.974-2.895 1.475-4.37 4.37-.779 1.528-.974 3.923Q4 36.798 4 40.8V42a2 2 0 0 0 2 2Zm4.708-34.504Q10 11.17 10 13t.708 3.504q.683 1.615 1.928 2.86 1.245 1.245 2.86 1.928Q17.17 22 19 22t3.504-.708q1.615-.683 2.86-1.928 1.245-1.245 1.928-2.86Q28 14.83 28 13t-.708-3.504q-.683-1.615-1.928-2.86-1.245-1.245-2.86-1.928Q20.83 4 19 4t-3.504.708q-1.615.683-2.86 1.928-1.245 1.245-1.928 2.86Zm4.756 7.04Q14 15.07 14 13q0-2.071 1.464-3.536Q16.93 8 19 8q2.071 0 3.535 1.464Q24 10.93 24 13q0 2.071-1.465 3.535Q21.072 18 19 18t-3.536-1.465Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
